import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useFamilyContext } from '../context/FamilyContext';

const { FiX, FiShoppingCart, FiPlus, FiCheck } = FiIcons;

export default function ShoppingListSelectorModal({ ingredients, onClose, onConfirm }) {
  const { state } = useFamilyContext();
  const { shoppingLists } = state;
  const [selectedListId, setSelectedListId] = useState(shoppingLists[0]?.id || 'new');
  const [newListName, setNewListName] = useState('Einkaufsliste');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(selectedListId, selectedListId === 'new' ? newListName : null);
  };

  const ingredientCount = ingredients ? ingredients.split(',').length : 0;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-30" onClick={onClose} />
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative bg-white rounded-xl shadow-xl max-w-sm w-full p-6"
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg font-semibold text-gray-900">
              Zu Einkaufsliste hinzufügen
            </h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg mb-6 flex items-start space-x-3">
            <SafeIcon icon={FiShoppingCart} className="w-5 h-5 text-blue-600 mt-0.5" />
            <div>
                <p className="text-sm font-medium text-blue-900">{ingredientCount} Zutaten gefunden</p>
                <p className="text-xs text-blue-700 mt-1 line-clamp-2">{ingredients}</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Ziel-Liste wählen
              </label>
              <div className="space-y-2 max-h-40 overflow-y-auto">
                <label 
                    className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors ${selectedListId === 'new' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}
                >
                    <input 
                        type="radio" 
                        name="list" 
                        value="new" 
                        checked={selectedListId === 'new'} 
                        onChange={() => setSelectedListId('new')}
                        className="sr-only" 
                    />
                    <div className="w-5 h-5 rounded-full border border-gray-300 flex items-center justify-center mr-3 bg-white">
                        {selectedListId === 'new' && <div className="w-2.5 h-2.5 rounded-full bg-blue-600" />}
                    </div>
                    <span className="text-sm font-medium text-gray-900">Neue Liste erstellen</span>
                </label>

                {shoppingLists.map(list => (
                    <label 
                        key={list.id}
                        className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors ${selectedListId === list.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}
                    >
                        <input 
                            type="radio" 
                            name="list" 
                            value={list.id} 
                            checked={selectedListId === list.id} 
                            onChange={() => setSelectedListId(list.id)}
                            className="sr-only" 
                        />
                         <div className="w-5 h-5 rounded-full border border-gray-300 flex items-center justify-center mr-3 bg-white">
                            {selectedListId === list.id && <div className="w-2.5 h-2.5 rounded-full bg-blue-600" />}
                        </div>
                        <div>
                            <span className="block text-sm font-medium text-gray-900">{list.name}</span>
                            <span className="block text-xs text-gray-500">{list.items?.length || 0} Artikel</span>
                        </div>
                    </label>
                ))}
              </div>
            </div>

            {selectedListId === 'new' && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }}>
                     <label className="block text-sm font-medium text-gray-700 mb-1">
                        Name der neuen Liste
                    </label>
                    <input 
                        type="text" 
                        value={newListName} 
                        onChange={(e) => setNewListName(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500" 
                        placeholder="z.B. Abendessen Einkauf"
                        required={selectedListId === 'new'}
                    />
                </motion.div>
            )}

            <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
              >
                Hinzufügen
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}